import { Injectable } from '@angular/core';

declare global {
  interface Window {
    ym?: (counterId: number, action: string, ...args: unknown[]) => void;
  }
}

/** Цели, на которые обучаются кампании Яндекс.Директа. */
export type MetrikaGoal =
  'test_start' | 'test_complete' | 'test_share' | 'ego_analyze' | 'pro_click';

export const METRIKA_COUNTER_ID = 106826485;

/**
 * Обёртка над счётчиком Яндекс.Метрики.
 * Счётчик подключается в index.html, поэтому все вызовы защищены проверкой:
 * при блокировщике рекламы или в тестах window.ym отсутствует.
 */
@Injectable({ providedIn: 'root' })
export class MetrikaService {
  /** Хит для SPA — Метрика сама не видит переходы по роутам Angular. */
  hit(url: string): void {
    this.call('hit', url, {
      title: typeof document !== 'undefined' ? document.title : undefined,
      referer: typeof document !== 'undefined' ? document.referrer : undefined,
    });
  }

  reachGoal(goal: MetrikaGoal, params?: Record<string, unknown>): void {
    this.call('reachGoal', goal, params);
  }

  private call(action: string, ...args: unknown[]): void {
    try {
      window.ym?.(METRIKA_COUNTER_ID, action, ...args);
    } catch {
      // Аналитика не должна ронять приложение.
    }
  }
}
